import React, {useMemo} from 'react';
import Link from 'next/link';
import styled, {css} from 'styled-components';

import theme, {bp, color} from 'settings/theme';


type Props = {
  product: any,
  activeTab: string,
  name: string,
  label: string,
  shortLabel?: string
};

type StyledProps = {
  isActive: boolean,
};

// Product Header
const Component: React.FC<Props> = (props) => {

  const tabName = props.name === 'details' ? '' : props.name;

  return (

    <StyledComponent isActive={props.name === props.activeTab} className="productTab">

      <Link href="/products/[slug]/[[...tab]]" as={`/products/${props.product.slug}/${tabName}`}>
        <div className="productTab-label">{props.label}</div>
        <div className="productTab-shortLabel">{props.shortLabel || props.label}</div>
      </Link>

    </StyledComponent>
  
  );

};


export default Component;




// Styles
const StyledComponent = styled.div<StyledProps>`

  display: flex;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  border-right: solid 1px ${color.lines};
  
  a{

    display: flex;
    align-items: center;
    width: 100%;
    height: calc(100% + 1px);
    padding-left: 8px;
    padding-right: 8px;
    color: ${color.grey(40)};
    font-family: ${theme.typography.fontFamilySecondary};
    font-size: 11px;
    font-weight: bold;
    border-bottom: solid 1px ${color.lines};
    transition: all 0.15s ease-out;

    &:hover{
      border-bottom: solid 1px ${color.pageBackground};
      background-color: ${color.pageBackground};
    }

  }

  .productTab-label{
    display: none;
    white-space: nowrap;
  }

  .productTab-shortLabel{
    white-space: nowrap;
  }

  ${props => props.isActive && css`
    a{
      border-bottom: solid 1px ${color.pageBackground};
      background-color: ${color.pageBackground};
    }
  `}

  @media (min-width: 370px) {

    a{
      padding-left: 12px;
      padding-right: 12px;
      font-size: 12px;
    }

  }

  @media (min-width: ${bp(4)}) {

    a{
      padding-left: 20px;
      padding-right: 20px;
      font-size: 14px;
    }

    .productTab-label{
      display: block;
    }

    .productTab-shortLabel{
      display: none;
    }

  }


`;



